import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpResponse } from "@angular/common/http";
import { ProviderService } from "../provider.service"
import Swal from "sweetalert2";
import { OrganizationService } from '../../organization-management/organization.service';
@Component({
  selector: 'app-edit-provider',
  templateUrl: './edit-provider.component.html',
  styleUrls: ['./edit-provider.component.css']
})
export class EditProviderComponent implements OnInit {


  coursePlanResponse: any;
  providerForm: FormGroup;
  formSubmitted: boolean = false;
  showDesciptionError: boolean = true;
  featureList = [];
  finalFeatureList = [];
  temp: any;
  desciptionName: string;
  providerId: string;
  organizationList = []
  planRequest = {
    courseproviderId: null,
    title: null,
    subTitle: null,
    price: null,
    featureList: [],
    sortOrder: null
  }
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private PlanService: ProviderService,
    private OrganizationService:OrganizationService
  ) { }

  ngOnInit() {
    this.getOrgs();
    this.providerId = this.route.snapshot.params["providerId"];
    this.initialiseForms();
    this.getplanById();

  }

  getplanById() {
    this.spinner.show();
    let query = "providerId=" + this.providerId;
    this.PlanService.getplanListById(query).subscribe(res => {
      if ((res["status"] = "Success")) {
        this.coursePlanResponse = res.data.providerList[0];
        this.updateForm();
        this.spinner.hide()
      } else {
        this.spinner.show()
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });

  }

  getOrgs() {
    let query = ""
    this.OrganizationService.getOrganizationsApi(query).subscribe(res => {
      this.spinner.show();
      if ((res["status"] == "Success")) {
        this.organizationList = res.data.organizationList;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });

  }

  initialiseForms() {
    this.providerForm = this.fb.group({
      name: ["", [Validators.required]],
      mobile: ["", [Validators.required]],
      mobileFormat: ["", [Validators.required]],
      role: ["", [Validators.required]],
      organizationId:["", [Validators.required]],
      email:["", [Validators.required, Validators.pattern(this.emailPattern)]],
      address: [""],
      link: [""],

    });
  }

  onlyNumberKey(event) {
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  updateForm() {
    this.providerForm.patchValue({
      name: this.coursePlanResponse["name"],
      mobile: this.coursePlanResponse["mobile"],
      mobileFormat: this.coursePlanResponse["mobile"],
      email: this.coursePlanResponse["email"],
      address: this.coursePlanResponse["address"],
      role: this.coursePlanResponse["role"],
      organizationId: this.coursePlanResponse["organizationId"],
      link:this.coursePlanResponse['link']
    });
    this._mobileFormat();
  }





  Addplan() {
    this.formSubmitted = true;
    if (this.providerForm.valid) {
      let request = this.providerForm.value;
      request['providerId'] = this.providerId;
      request['mobile'] = request['mobile'].toString();
      delete request['mobileFormat']
      if (request['organizationId'] == '' || request['organizationId'] == null ) {
        request['organizationId'] = ""
     }
     if (request['link'] == '' || request['link'] == null ) {
       request['link'] = ""
    }
      this.PlanService.Editplan(request).subscribe(data => {
        if ((data["message"] = "Success")) {
          Swal.fire("Success", "Provider Updated Successfully!", "success");
          this.router.navigate(["/main/provider/view"]);
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }
  }

  checkRole() {
    if(this.providerForm.controls.role.value == 'biller') {
      this.providerForm.controls.organizationId.setValidators([Validators.required])
      this.providerForm.controls.organizationId.updateValueAndValidity();
    } else {
      this.providerForm.controls.organizationId.clearValidators()
    }
  }
  mobileNumber=""
  _mobileFormat() {
    var phone = this.providerForm.value.mobileFormat.toString();
    phone = phone.replace('(', '').replace(')', '').replace(new RegExp('-', 'g'), '').replace(new RegExp(' ', 'g'), '')
    this.formatMobileNumber(phone)
  }

  formatMobileNumber(phone: any) {
    var str = phone.toString();
    var strFormat;
    if (this.mobileNumber !== str) {
      this.mobileNumber = str;
      if (str.length <= 3)
        strFormat = '(' + str.substr(0, 3) + ')'
      if (str.length > 3 && str.length <= 6)
        strFormat = '(' + str.substr(0, 3) + ')' + '' + str.substr(3, 3);
      if (str.length > 6)
        strFormat = '(' + str.substr(0, 3) + ')' + ' ' + str.substr(3, 3) + '-' + str.substr(6, 4);
      this.providerForm.controls['mobile'].setValue(str);
      this.providerForm.controls['mobileFormat'].setValue(strFormat);
    }
  }

  cancel() {
    this.router.navigate(["/main/provider/view"]);
  }
}


